//是否包含教材
const hasTextbook = [
  {code: '是',value: '1'},
  {code: '否',value: '0'},
]

export default {
  hasTextbook: hasTextbook,
}